import { propertyHeadline, propertyCategory, propertyCityState } from './property-display';

type AnyRecord = Record<string, unknown>;

/**
 * Resolves a property's neighborhood from its nested location or flat field.
 *
 * @param property - A property record (nested or flat shape).
 * @returns The neighborhood, if present.
 */
function propertyNeighborhood(property: AnyRecord): string | undefined {
  const loc = property.location as AnyRecord | undefined;
  return (loc?.neighborhood as string) || (property.neighborhood as string);
}

/**
 * Builds a searchable label for a property in the partnerships picker.
 *
 * Concatenates headline, category, and city (nested-first via display helpers)
 * so the user can search by any of those fields.
 *
 * @param property - A property record (nested or flat shape).
 * @returns A space-separated label string suitable for substring matching.
 */
export function partnershipsPropertyLabel(property: AnyRecord): string {
  const { city } = propertyCityState(property);
  const parts = [
    propertyHeadline(property),
    propertyCategory(property),
    city,
    propertyNeighborhood(property),
  ].filter(Boolean);
  return parts.join(' ');
}
